import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import PrimaryContent from "../Components/Utilities/PrimaryContent";
import PrimaryHeading from "../Components/Utilities/PrimaryHeading";

export default function NotFound() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/login");
    }
  };

  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      fontFamily: "sans-serif",
    }}>
      <PrimaryHeading sx={{ mb: 2, color: "#ff4d4f" }}>404</PrimaryHeading>
      <PrimaryContent sx={{ mb: 2 }}>Page Not Found</PrimaryContent>
      <Button
        variant="outlined"
        color="neutral"
        onClick={handleBack}
        sx={{
          fontFamily: "Lato",
          fontWeight: 400,
          fontSize: "14px",
          border: "1px solid rgba(14, 41, 102, 1)",
          textTransform: "none",
          borderRadius: "10px",
          color: "rgba(14, 41, 102, 1)",
          py: 1,
        }}
      >
        Back
      </Button>
    </div>
  );
}
